import $ from 'jquery';
import axios from 'axios';
import 'slick-carousel';
import sleep from '@/_vue/helpers/sleep';
import Globals from '@/helpers/globals';

const { $body } = Globals;

const Product = {
    init() {
        $body.on('click', '.js-product-favorite', e => this.handleFavorite(e));
        $body.on('click', '.js-product-add-to-basket', e => this.handleAddToBasket(e));

        this.$basketCount = $('.js-header-basket-count');
        this.$slider = $('.js-product-slider');

        if (this.$slider.length) this.initSlider();
    },

    async animateBasket($button, count) {
        this.$basketCount.addClass('animate');
        this.$basketCount.html(count);
        $button.removeClass('is-loading');
        $button.addClass('success');

        const $buttonText = $button.find('.js-product-add-to-basket-text');
        const $buttonSuccess = $button.find('.js-product-add-to-basket-success');

        $buttonText.addClass('sr-only');
        $buttonSuccess.removeClass('sr-only');

        await sleep(1000);
        $button.removeClass('success');
        $buttonText.removeClass('sr-only');
        $buttonSuccess.addClass('sr-only');
    },

    async handleFavorite(e) {
        const $favorite = $(e.currentTarget);
        const productId = $favorite.attr('data-id');

        $favorite.addClass('animate');

        const { data } = await axios.post(window.route('favorites.favorite'), {
            variant_id: productId,
        });

        $favorite.toggleClass('is-favorited', data.is_favorite);

        await sleep(650);
        $favorite.removeClass('animate');
    },

    async handleAddToBasket(e) {
        const $button = $(e.currentTarget);
        const productId = parseInt($button.attr('data-id'), 10);
        const productInStock = parseInt($button.attr('data-inStock'), 10);
        let productAmount = parseInt($button.parents('.js-product-parent').find('.js-input-value').val(), 10);

        if ($button.attr('data-amount')) productAmount = parseInt($button.attr('data-amount'), 10);

        $button.addClass('is-loading');

        const { data } = await axios.post(window.route('cart.store'), {
            amount: productAmount || 1,
            variant_id: productId,
            in_stock: productInStock,
        });

        await sleep(500);
        this.animateBasket($button, data.basket_count);

        await sleep(500);
        $button.removeClass('is-loading');
        this.$basketCount.removeClass('animate');
    },

    initSlider() {
        this.$slider.slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
            dots: true,
            fade: true,
            infinite: true,
            lazyLoad: 'anticipated',
            mobileFirst: true,
            slidesToShow: 1,
            touchThreshold: 30,
        });
    },
};

export default Product;
